import FleetModal, { useAsyncModal } from '@/libs/antd/components/Modal';
import FleetTitle from '@/libs/antd/components/Title';
import { formatCurrency } from '@/libs/antd/formater';
import { Table } from 'antd';
import { FC } from 'react';

export const useBrandDetailModal = () => {
	return useAsyncModal<
		{
			brandDetailId: number;
			brandId: number;
			brandName: string;
			brandTypeId: number;
			brandTypeName: string;
			unit: number;
			amount: number;
		}[],
		void
	>();
};

const BrandDetailModal: FC<ReturnType<typeof useBrandDetailModal>> = (
	props,
) => {
	return (
		<FleetModal
			{...props.modal}
			width={940}
			closable={false}
			buttonPosition="end"
			okText="BACK"
			cancelButtonProps={{
				hidden: true,
			}}
			onOk={async () => props.close()}
		>
			<FleetTitle>View Brand & Detail Jenis Unit</FleetTitle>
			<Table
				bordered
				pagination={false}
				scroll={{ x: 'max-content' }}
				dataSource={props.data ?? []}
				style={{ marginTop: 20 }}
				columns={[
					{
						title: 'Brand',
						render: (_, record) => record.brandName,
					},
					{
						title: 'Type ',
						render: (_, record) => record.brandTypeName,
					},
					{
						title: 'Jumlah Unit ',
						render: (_, record) => record.unit,
					},
					{
						title: 'Amount ',
						render: (_, record) => formatCurrency(record.amount),
					},
				]}
			/>
		</FleetModal>
	);
};

export default BrandDetailModal;
